import NotificationsPage from './notifications-page'

export default NotificationsPage